import React, { Component } from 'react'
import HeaderComponent from '../../shared/components/header/headerComponent'
import TopSecSubMenuComponent from '../../shared/components/header/topSecSubMenuComponent'
import FooterComponent from '../../shared/components/footer/footerComponent'

class HowToPlayLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {
    }
    render() {
        return (
            <React.Fragment>
                <HeaderComponent />
                <TopSecSubMenuComponent />
                {this.props.children}
                <FooterComponent />
            </React.Fragment>
        )
    }
}

export default HowToPlayLayout;